export const OnboardingStep = {
  First: 0,
  Second: 1,
  Third: 2,
};
